import React, { Component } from "react";
import { setFullName, setMobile, setNin, setServiceType } from "../core/actions/common";
import { connect } from "react-redux";
import { State } from '../core/reducers';
import appconfig from "../appconfig.json";
import axios from 'axios';

export interface CommonProps {
    serviceType: string;
    fullName: string;
    nin: string;
    mobile: string;
    token: string;
    setServiceType(serviceType: string): void;
    setFullName(fullName: string): void;
    setNin(nin: string): void;
    setMobile(mobile: string): void;
    otpToken: string;
    setMeetingID(meetingID: string): void;
    setMeetingLink(meetingLink: string): void;
    setMeetingStartTime(meetingStartTime: string): void;
}
class MobileAPP extends Component {
    constructor(public props: CommonProps) {
      
        super(props);
        
    }

    componentDidMount(): void {
        const queryParams = new URLSearchParams(window.location.search);
        const isPublic: any = queryParams.get("isPublic");
        const fullName:any = queryParams.get("fullname");
        const nin:any = queryParams.get("nin");
        const mobile:any = queryParams.get("mobile");
        let serviceType:any = queryParams.get("serviceType");
        this.props.setFullName(fullName);
        this.props.setNin(nin);
        this.props.setMobile(mobile);
        this.props.setServiceType(serviceType);
        //let url = "";
        serviceType = "poc2-inquiry";
        if( serviceType == null || serviceType == "" ){
            alert("Please provide servie");
       }else if( nin == "" || nin == null ){
        alert("Please provide nin number");
       }else if( mobile == "" || mobile == null ){
        alert("Please provide mobile number");
       }else if( fullName == "" || fullName == null ){
        alert("Please provide fullName");
       }else if(serviceType !== null && fullName !== null && nin !== null && mobile !== null && serviceType !== null){
            //url = "/?isPublic=true&config=true";
            //window.location.href = window.location.origin + url;
            //this.initiateNewCall(fullName, serviceType, mobile,nin, isPublic);
            //const config = {
            //    headers: {
            //        // Authorization: `Bearer ${props.otpToken}`,
            //        api_token: props.otpToken
            //    }
            //};
            //alert(JSON.stringify(options));
            const requestBody = {
                "fullName": fullName,
                "serviceType": serviceType,
                "mobileNumber": mobile,
                "nin": nin
            };


            const url = appconfig.azure_url + "/api/customer-meeting";
            axios.post(url, requestBody).then(response => {

                //let meetingID: string = response.data.id;
                //let meetingLink: string = response.data.meetingLink;

                //setMeetingID(meetingID);
                //setMeetingLink(meetingLink);
                //var time = new Date();
                //setMeetingStartTime(time.getTime().toString());
                //meetingLink = meetingLink.replace("https://gosivvwebapp-as.azurewebsites.net", "http://localhost:3000");
                //window.location.href = meetingLink + "&meetingID=" + response.data.id + "&fullname=" + fullName + "&isPublic=" + isPublic + "&serviceType=" + serviceType;
                window.location.href = response.data.meetingLink + "&meetingID=" + response.data.id + "&isPublic=" + isPublic + "&serviceType=" + serviceType;

            }).catch(error => {
                alert(JSON.stringify(error));
            })
        }
        //const url = "/?isPublic=true&config=true&fullname=dasarathi&nin=1011012345&mobile=9087654321&serviceType=gosi-ppa&client=null";
         
    }

    //const initiateNewCall = (fullName: string | null, serviceType: string | null, mobile: string | null, nin: string | null, isPublic: string | null) => {
    //    //alert(props.otpToken);
    //    //let browser = (window as any)["getBrowser"]();
    //    //let mic = document.getElementById('micList') as HTMLSelectElement;
    //    //if (mic.value == "" && browser != "Safari") {
    //    //    //alert("??? ????? ?? ????? ?????? ????? ???????? ???????????");
    //    //    displayActivateAlert();
    //    //    return;
    //    //}

    //    /* const options = {
    //      headers: {
    //          'api_token': props.otpToken,
    //          'Access-Control-Allow-Origin': "*"
    //      }
    //    }; */

    //    const config = {
    //        headers: {
    //            // Authorization: `Bearer ${props.otpToken}`,
    //            api_token: this.props.otpToken
    //        }
    //    };
    //    //alert(JSON.stringify(options));
    //    const requestBody = {
    //        "fullName": fullName,
    //        "serviceType": serviceType,
    //        "mobileNumber": mobile,
    //        "nin": nin
    //    };


    //    const url = appconfig.azure_url + "/api/customer-meeting";
    //    axios.post(url, requestBody, config).then(response => {

    //        let meetingID: string = response.data.id;
    //        let meetingLink: string = response.data.meetingLink;

    //        setMeetingID(meetingID);
    //        setMeetingLink(meetingLink);
    //        var time = new Date();
    //        setMeetingStartTime(time.getTime().toString());
    //        //meetingLink = meetingLink.replace("https://gosivvwebapp-as.azurewebsites.net", "http://localhost:3000");
    //        //window.location.href = meetingLink + "&meetingID=" + response.data.id + "&fullname=" + fullName + "&isPublic=" + isPublic + "&serviceType=" + serviceType;
    //        window.location.href = meetingLink + "&meetingID=" + response.data.id + "&isPublic=" + isPublic + "&serviceType=" + serviceType;

    //    }).catch(error => {
    //        alert(JSON.stringify(error));
    //    })
    //}

    render() {
        return (
            <div>
                
            </div>
        );
    }
}



const mapStateToProps = (state: State, props: CommonProps) => ({
    serviceType: state.common.serviceType
});

const mapDispatchToProps = (dispatch: any, props: CommonProps) => ({
    setServiceType: (serviceType: string) => dispatch(setServiceType(serviceType)),
    setFullName: (fullName: string) => dispatch(setFullName(fullName)),
    setNin: (nin: string) => dispatch(setNin(nin)),
    setMobile: (mobile: string) => dispatch(setMobile(mobile))
});

const connector: any = connect(mapStateToProps, mapDispatchToProps);
export default connector(MobileAPP);
//export default MobileAPP;
